// import moment from 'moment'
// ------------------------------------
// Constants
// ------------------------------------
export const INIT_MEMBER = 'INIT_MEMBER'
export const CHANGE_MEMBER = 'CHANGE_MEMBER'
export const RESET_MEMBER = 'RESET_MEMBER'
// ------------------------------------
// Logic Actions
// ------------------------------------

// ------------------------------------
// Basic Actions
// ------------------------------------

export function getMemberWithId(memberId) {
  return (dispatch, getState) => {
    const { members } = getState()
    const member = members.list.filter(m => {
      return m.id === memberId
    })[0]
    if (member) {
      dispatch({
        type: INIT_MEMBER,
        payload: member,
        previous: Object.assign({}, member)
      })
    }
  }
}
export function changeCurrentMember(member, changes) {
  return (dispatch, getState) => {
    dispatch({
      type: CHANGE_MEMBER,
      payload: Object.assign({}, changes)
    })
  }
}
export function resetMember() {
  return (dispatch, getState) => {
    dispatch({
      type: RESET_MEMBER
    })
  }
}
export const actions = {
  getMemberWithId,
  changeCurrentMember,
  resetMember
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [INIT_MEMBER]: (state, action) =>
    Object.assign({}, state, {
      didChange: false,
      previous: action.previous,
      member: action.payload
    }),
  [CHANGE_MEMBER]: (state, action) => {
    let newState = Object.assign({}, { ...state })

    const changes = action.payload
    for (let property in changes) {
      if (changes.hasOwnProperty(property)) {
        newState.member[property] = changes[property]
      }
    }
    newState.didChange = true
    return newState
  },
  [RESET_MEMBER]: (state, action) =>
    Object.assign({}, state, {
      member: { ...state.previous },
      didChange: false
    })
}
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  didChange: false,
  previous: null,
  member: null
}
export default function memberInfoReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/redux/modules/currentMember.js